import type { ReactNode } from 'react';

export const symbol_not_accessible_forward: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m792-83-68-67h23q0 13.04-8.47 21.52t-21.5 8.48q-13.03 0-21.53-8.48-8.5-8.48-8.5-21.52v-37L560-314H430q-49 0-73.5-38t-4.5-81l28-61L82-792q-9-9.07-9-21.53Q73-826 82.05-835q9.06-9 21.5-9 12.45 0 21.45 9l710 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83Zm-45-216-94-94h19q30.94 0 52.97 22.03Q747-348.94 747-318v19ZM556-490 363-682h168q40 0 62.5 32t6.5 66l-44 94ZM313.19-80Q234-80 177-137t-57-136q0-79 57-136t136-57v60q-54 0-93.5 39.5T180-273q0 54 39.5 93.5T313-140q54 0 92.5-37.5T444-284h60q0 93-55.81 148.5-55.82 55.5-135 55.5ZM580.5-735.42q-21.5-21.42-21.5-51.5t21.42-51.58q21.42-21.5 51.5-21.5t51.58 21.42q21.5 21.42 21.5 51.5t-21.42 51.58q-21.42 21.5-51.5 21.5t-51.58-21.42Z"
		/>
	</svg>
);
